import React from "react";
import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";

const ProductCard = ({ product, index = 0 }) => {
  return (
    <Link
      to={`/products/${product.slug}`}
      data-testid={`product-card-${product.slug}`}
      className="group block animate-fade-up"
      style={{ animationDelay: `${index * 80}ms` }}
    >
      <div className="relative overflow-hidden bg-cream-alt aspect-[4/5]">
        <img
          src={product.image}
          alt={`${product.name} - Premium India Export | Gralon Global`}
          loading="lazy"
          className="absolute inset-0 w-full h-full object-cover transition-transform duration-700 ease-out group-hover:scale-[1.06]"
        />
        <div className="absolute top-4 left-4 px-3 py-1 bg-cream/90 backdrop-blur-sm">
          <span className="text-[10px] tracking-[0.25em] uppercase text-forest-dark">
            {product.category}
          </span>
        </div>
        <div className="absolute bottom-4 right-4 w-10 h-10 rounded-full bg-cream/90 backdrop-blur-sm flex items-center justify-center text-forest-dark opacity-0 group-hover:opacity-100 transition-opacity duration-500">
          <ArrowUpRight strokeWidth={1.5} className="w-4 h-4" />
        </div>
      </div>
      <div className="mt-5 flex items-baseline justify-between gap-4">
        <div>
          <h3 className="font-serif text-2xl text-ink leading-tight">
            {product.name}
          </h3>
          <p className="italic text-sm text-muted mt-1">{product.botanical_name}</p>
        </div>
      </div>
      <p className="mt-3 text-sm text-muted leading-relaxed">{product.tagline}</p>
    </Link>
  );
};

export default ProductCard;
